import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Switch, useRouteMatch } from 'react-router';
import { PageNotFound } from 'ui-toolkit';
import { AdministrationRouter } from './admin/AdministrationRouter';
import { ClientCompaniesRouter, LenderCompaniesRouter } from './admin/ClientLenderCompaniesRouter';
import { OrdersPage } from '../pages/orders/OrdersPage';
import { AccountingRouter } from './admin/AccountingRouter';
import { CreateOrderPage } from '../pages/create/CreateOrderPage';
import { AdminOrderRouter } from './admin/AdminOrderRouter';
import { EditConversationPage } from '../pages/conversations/EditConversationPage';
import { useLoginRedirect } from 'store/authentication/useLoginRedirect';
import { DocumentDownloadContainer } from 'pages/order/documentsPortal/DocumentDownloadContainer';
import { DashboardContainer } from '../components/pcDashboard/DashboardContainer';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { AccessControlCheck } from 'components/accessControl/AccessControlCheck';
import { eAccessControlUserType } from '../ui-toolkit/enums/eAccessControlUserType';

/*
 * These are the routes for Chloe, an employee of Spruce/Zillow.
 */
export const AdminRoutes: React.FC = () => {
  const { path } = useRouteMatch();
  const goLoginRedirect = useLoginRedirect();
  return (
    <AccessControlCheck
      allowedPermissions={[ePermissions.AdminRead]}
      actionOnFailure={() => goLoginRedirect(eAccessControlUserType.Admin)}
    >
      <Switch>
        <Route path={`${path}`} exact render={({ location: { pathname } }) => <Redirect to={`${pathname}/orders`} />} />
        <Route path={`${path}/accounting`} component={AccountingRouter} />
        <Route path={`${path}/administration`} component={AdministrationRouter} />
        <Route path={`${path}/clients`} component={ClientCompaniesRouter} />
        <Route path={`${path}/conversations/:conversationId`} exact component={EditConversationPage} />
        <Route path={`${path}/dashboard`} exact component={DashboardContainer} />
        <Route path={`${path}/documents/:documentId/download`} exact component={DocumentDownloadContainer} />
        <Route path={`${path}/lenders`} component={LenderCompaniesRouter} />
        <Route path={`${path}/order/create`} exact component={CreateOrderPage} />
        <Route path={`${path}/order/:orderId`} component={AdminOrderRouter} />
        <Route path={`${path}/orders`} exact component={OrdersPage} />
        <Route component={PageNotFound} />
      </Switch>
    </AccessControlCheck>
  );
};
